<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli/' }, { label: 'Utenti Gestione Area Compagnia Spettacolo', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">UTENTI GESTIONE AREA COMPAGNIA SPETTACOLO</h1>
</section>

<section class="px-container">                     

    <p-table #table 
        [loading]="loading" 
        [value]="utenti" 
        responsiveLayout="stack" 
        [breakpoint]="'960px'" 
        styleClass="p-datatable-striped" 
        [paginator]="true" 
        [showCurrentPageReport]="true" 
        [rowHover]="true" 
        [globalFilterFields]="['username','email', 'spettacolo']" 
        currentPageReportTemplate="{first} di {last} su {totalRecords} utenti"
        [rows]="5" 
        showGridlines
        [rowsPerPageOptions]="[5, 10, 20, 50]">            
        <ng-template pTemplate="caption">                        
            <div class="flex lg:flex-row flex-col gap-4 w-full">
                <div class="lg:w-3/4 w-full">
                    <span class="block w-full p-input-icon-left">
                        <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                        <input pInputText type="text" (input)="onGlobalFilter(table, $event)" placeholder="Cerca..." class="w-full indent-6" />
                    </span>
                </div>
                <div class="lg:w-1/4 w-full">                    
                    <button class="w-full h-full btn-outln-backoffice text-center" type="button" (click)="add = true">                
                        <i class="bi bi-plus"></i>
                        Aggiungi utente
                    </button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="email" class="w-2/4">Email <span class="inline-flex"><p-sortIcon field="email" /></span></th>
                <th pSortableColumn="username" class="w-1/4">Username <span class="inline-flex"><p-sortIcon field="username" /></span></th>                                    
                <th class="w-1/4 !text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-utente>
            <tr>
                <td><span class="p-column-title">Email</span>{{utente.email || '-'}}</td>
                <td><span class="p-column-title">Username</span>{{utente.username || '-'}}</td>                
                <td class="md:justify-center justify-between flex"><span class="p-column-title">Azioni</span>

                    <div class="flex flex-row items-center justify-center">                                                            
                        <i class="bi bi-pencil lg:text-3xl text-2xl hover:text-accent cursor-pointer" (click)="onOpenEdit(utente)"></i>                        
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #delete>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()">Elimina</button>
                                        <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium"  (click)="onClose()">Annulla</button>                                        
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>

                        <i class="bi bi-trash lg:text-3xl text-2xl hover:text-accent cursor-pointer" (click)="onOpenDelete($event, utente)" ></i>
                    </div>
                    
                </td>                    
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessun utente trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>

<!-- MODAL ADD/EDIT CAST -->
<p-dialog [visible]="(add || edit)" [style]="{width: '50%'}" [header]="add ? 'Aggiungi utente' : 'Modifica utente'" [focusOnShow]="false" [modal]="true" class="p-fluid" (visibleChange)="onCloseModal()">
    <ng-template pTemplate="content">
        
        <p class="italic text-sm mb-4" *ngIf="add">Se l'utente non è ancora presente, un'email verrà inviata all'indirizzo email inserito contenente le credenziali d'accesso e l'informativa sul portale di accreditamenti compagnie.</p>

        <form [formGroup]="formUtente" (ngSubmit)="add ? onAdd() : onEdit()">
            <div class="flex flex-col gap-6">
                <div class="flex lg:flex-row flex-col gap-6">
                    <div class="lg:w-1/2 w-full">
                        <label>Username</label>
                        <input type="text" pInputText placeholder="Username" formControlName="username" name="username" id="username" />                        
                    </div>
                    <div class="lg:w-1/2 w-full">
                        <label>* Email</label>
                        <input type="text" pInputText placeholder="Email" formControlName="email" />
                        @if (formUtente.get('email')?.hasError('required') && (formUtente.get('email')?.dirty || formUtente.get('email')?.touched)) {<small class="text-red-600 block mt-4 font-medium">L'email è obbligatoria!.</small>}
                        @if (formUtente.get('email')?.hasError('email') && (formUtente.get('email')?.dirty || formUtente.get('email')?.touched)) {<small class="text-red-600 block mt-4 font-medium">Inserire un'email valida!.</small>}
                    </div>
                </div>
                <div class="flex lg:flex-row flex-col gap-6">
                    <div class="lg:w-1/2 w-full">
                        <label>{{add ? '* ' : ''}}Password</label>
                        <p-password [toggleMask]="true" [feedback]="true" formControlName="password" placeholder="Password" class="w-full grid" autocomplete />
                        @if (formUtente.get('password')?.hasError('required') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched)) {<small class="text-red-600 block mt-4 font-medium">La password è obbligatoria!.</small>}
                        @if (formUtente.get('password')?.hasError('minlength') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched)) {<small class="text-red-600 block mt-4 font-medium">Inserire almeno 4 caratteri!.</small>}
                        @if (formUtente.hasError('mismatch') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched) && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)) {<small class="text-red-600 block mt-4 font-medium">Le due password non combaciano!.</small>}
                    </div>
                    <div class="lg:w-1/2 w-full">
                        <label>{{add ? '* ' : ''}}Conferma Password</label>
                        <p-password [toggleMask]="true" [feedback]="true" formControlName="confirm_password" placeholder="Conferma Password" class="w-full grid" autocomplete />         
                        @if(formUtente.get('confirm_password')?.hasError('required') && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)) {<small class="text-red-600 block mt-4 font-medium">La password è obbligatoria!.</small>}
                        @if(formUtente.get('confirm_password')?.hasError('minlength') && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)){<small class="text-red-600 block mt-4 font-medium">Inserire almeno 4 caratteri!.</small>}
                        @if(formUtente.hasError('mismatch') && (formUtente.get('password')?.dirty || formUtente.get('password')?.touched) && (formUtente.get('confirm_password')?.dirty || formUtente.get('confirm_password')?.touched)){<small class="text-red-600 block mt-4 font-medium">Le due password non combaciano!.</small>}
                    </div>
                </div>                            
                <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formUtente.valid">{{add ? 'Aggiungi' : 'Modifica'}}</button>
            </div>
        </form>
    </ng-template>
</p-dialog>
<!-- MODAL ADD/EDIT CAST -->